export default __webpack_public_path__ + "static/06_AshWednesday-c260b5244d1d7ded791bb5f0a0a7b81c.pdf";